import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Producto } from 'src/app/core/dtos/producto';
import { ProductoResponse } from 'src/app/core/dtos/productoResponse';
import { environment } from 'src/environments/environment.development';


@Injectable({
  providedIn: 'root'
})
export class ProductoService {
  
  private apiUrl = `${environment.apiUrl}/Productos/`;

  constructor(private http: HttpClient) { }

  getProductos(usuarioId:number): Observable<ProductoResponse[]> {
    return this.http.get<ProductoResponse[]>(`${this.apiUrl}getAll?usuarioId=${usuarioId}`);
  }

  getProducto(id: number): Observable<Producto> {
    return this.http.get<Producto>(`${this.apiUrl}getById?id=${id}`);
  }

  crearProducto(usuarioId:number,producto: Producto): Observable<Producto> {
    return this.http.post<Producto>(`${this.apiUrl}create?usuarioId=${usuarioId}`, producto);
  }

  actualizarProducto(productoId: number, producto: Producto): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}edit?productoId=${productoId}`, producto);
  }

  eliminarProducto(productoId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}delete?productoId=${productoId}`);
  }
}
